import { NgModule } from '@angular/core';
import { LinkModule } from '@com-delta-idp/mnx-ui-kit';
import {
  ChangeStylesDirective,
  DividerComponent,
  EntryItemComponent,
  ToggleAreaComponent
} from '@com-delta-omnichannel/aura';
import { SnapshotComponent } from './snapshot.component';

@NgModule({
  declarations: [SnapshotComponent],
  imports: [
    LinkModule,
    EntryItemComponent,
    ToggleAreaComponent,
    DividerComponent,
    ChangeStylesDirective
  ],
  exports: [SnapshotComponent]
})
export class SnapshotModule {}
